import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ChatRoomMemberData } from '~/types';
import { fontStyle } from '~/styles/themes';

export default function MsgReceiverPicker({
  selectedCharacterId,
  setSelectedCharacter,
  avatars,
  showReceiverPicker,
}: {
  selectedCharacterId: string | null;
  setSelectedCharacter: (id: string) => void;
  avatars?: ChatRoomMemberData[] | null;
  showReceiverPicker: boolean;
}) {
  return showReceiverPicker ? (
    <PickerContainer>
      {avatars?.map((el) => (
        <ReceiverCharacterChip
          key={`ReceiverCharacterChip-${el.id}`}
          isSelected={selectedCharacterId === el.id}
          onClick={() => setSelectedCharacter(el.id)}
        >
          <AvatarPreviewImage
            src={el.thumbnail_url}
            alt={el.thumbnail_url}
            width={32}
            height={32}
          />
          <p>{`${selectedCharacterId === el.id ? 'To: ' : ''} ${el.name}`}</p>
        </ReceiverCharacterChip>
      ))}
    </PickerContainer>
  ) : (
    <></>
  );
}

const PickerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const ReceiverCharacterChip = styled.div<{ isSelected: boolean }>`
  ${({ theme, isSelected }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    height: fit-content;
    padding-right: 12px;
    border: 1px solid
      ${isSelected ? theme.themeColor.main_1 : theme.stroke.stroke_1};
    border-radius: 30px;
    background-color: ${theme.backgroundColor.bg_dark_4_alpha};
    color: ${isSelected ? theme.colors.white : theme.content.content_light_4};
    font-weight: ${fontStyle.text.body14_medium};
    backdrop-filter: blur(10px);
  `}
`;

const AvatarPreviewImage = styled.img`
  width: 32px;
  height: 32px;
  margin: 4px;
  margin-right: 8px;
  border-radius: 50%;
  object-fit: cover;
`;
